import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  type CaptureType,
  type KycCapture,
} from "../../../domain/entities/kyc-capture";
import { compressImage } from "../../../infrastructure/image/compress-image";
import { type KycDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export interface UploadCaptureArgs {
  requestId: string;
  type: CaptureType;
  file: Blob;
}

export const uploadCapture = createAsyncThunk<
  KycCapture,
  UploadCaptureArgs,
  { dispatch: KycDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.UPLOAD_CAPTURE, async ({ requestId, type, file }, { extra }) => {
  // Compress in the browser before sending — the field-reliability lever.
  const image = await compressImage(file);
  return await extra.kycRepo.uploadCapture(requestId, type, image);
});
